module.exports = __webpack_public_path__ + "img/4.cb8474ca.webp";